export default "__VITE_PUBLIC_ASSET__ab43c546__"